import {
    FormControl,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import PropTypes from "prop-types";

import { FormRow, FormSection, FormSectionHeader, InputContainer } from ".";

const multiSensorOptions = Array.from(
    { length: 9 },
    (_, i) => `Sensor ${i + 1}`,
);

/**
 * Daylight harvesting sensor configuration form section.
 *
 * @param root0 - The component props.
 * @param root0.settings - The current sensor settings.
 * @param root0.updateSettings - Callback to update sensor settings.
 * @returns The rendered sensor settings section.
 */
const SectionSensorSettings = ({ settings, updateSettings }) => (
    <FormSection>
        <FormSectionHeader>
            <h2>Daylight Harvesting (optional)</h2>
            <p>
                Title 24 stores and some non-Title 24 stores may require sensors
                to adjust settings based on the amount of daylight detected. The
                settings below apply to all sensors. Additional parameters must
                be configured at the lighting group level to properly configure
                daylight harvesting.
            </p>
        </FormSectionHeader>
        <FormRow>
            <InputContainer>
                <TextField
                    type="number"
                    value={settings.setpoint ?? 0}
                    onChange={(e) =>
                        updateSettings({ setpoint: Number(e.target.value) })
                    }
                    label="Primary Group Setpoint"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">lux</InputAdornment>
                        ),
                    }}
                />
            </InputContainer>
            <InputContainer>
                <TextField
                    type="number"
                    value={settings.offset ?? 0}
                    onChange={(e) =>
                        updateSettings({ offset: Number(e.target.value) })
                    }
                    label="Secondary Group Offset"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">lux</InputAdornment>
                        ),
                    }}
                />
            </InputContainer>
            <InputContainer>
                <FormControl fullWidth>
                    <InputLabel id="multi-sensor-label">
                        Multi Sensor
                    </InputLabel>
                    <Select
                        type="number"
                        value={settings.multiSensor ?? 0}
                        labelId="multi-sensor-label"
                        label="Multi Sensor"
                        onChange={({ target: { value } }) =>
                            updateSettings({
                                multiSensor: value === 0 ? null : Number(value),
                            })
                        }
                    >
                        <MenuItem value={0}>None</MenuItem>
                        {multiSensorOptions.map((option, i) => (
                            <MenuItem key={option} value={i + 1}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </InputContainer>
        </FormRow>
    </FormSection>
);

SectionSensorSettings.propTypes = {
    settings: PropTypes.object,
    updateSettings: PropTypes.func,
};

export default SectionSensorSettings;
